// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kHG1","rootMobile":"styles_rootMobile__2a7Wu"};